import { MIXPANEL_TOKEN } from '@/constants/TrackingConstants'
import Mixpanel from 'mixpanel-browser'

const mixpanel = Mixpanel
// Left to itself the SDK keeps utm_* from any past tagged visit as super properties for a year.
// Campaign attribution is replayed by `eventTracker` from the 30-day envelope instead
// (see attribution.ts); first-touch `initial_utm_*` people properties are unaffected.
mixpanel.init(MIXPANEL_TOKEN, { stop_utm_persistence: true })

export default mixpanel
